import { render, staticRenderFns } from "./Pelanggaran.vue?vue&type=template&id=53425d6d&scoped=true"
import script from "./Pelanggaran.vue?vue&type=script&lang=js"
export * from "./Pelanggaran.vue?vue&type=script&lang=js"
import style0 from "./Pelanggaran.vue?vue&type=style&index=0&id=53425d6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53425d6d",
  null
  
)

export default component.exports